import React from "../../_snowpack/pkg/react.js";
import {useTranslation} from "../../_snowpack/pkg/react-i18next.js";
import {Controller, useFormContext, useWatch} from "../../_snowpack/pkg/react-hook-form.js";
import {
  ActionGroup,
  Button,
  FormGroup,
  NumberInput,
  Switch
} from "../../_snowpack/pkg/@patternfly/react-core.js";
import {FormAccess} from "../../components/form-access/FormAccess.js";
import {HelpItem} from "../../components/help-enabler/HelpItem.js";
import {Time} from "./Time.js";
export const BruteForceDetection = ({
  save,
  reset
}) => {
  const {t} = useTranslation("realm-settings");
  const {
    handleSubmit,
    control,
    formState: {isDirty}
  } = useFormContext();
  const enable = useWatch({
    control,
    name: "bruteForceProtected"
  });
  const permanentLockout = useWatch({
    control,
    name: "permanentLockout"
  });
  return /* @__PURE__ */ React.createElement(FormAccess, {
    role: "manage-realm",
    isHorizontal: true,
    onSubmit: handleSubmit(save)
  }, /* @__PURE__ */ React.createElement(FormGroup, {
    label: t("common:enabled"),
    fieldId: "bruteForceProtected",
    hasNoPaddingTop: true
  }, /* @__PURE__ */ React.createElement(Controller, {
    name: "bruteForceProtected",
    defaultValue: false,
    control,
    render: ({onChange, value}) => /* @__PURE__ */ React.createElement(Switch, {
      id: "bruteForceProtected",
      label: t("common:on"),
      labelOff: t("common:off"),
      isChecked: value,
      onChange
    })
  })), /* @__PURE__ */ React.createElement(FormGroup, {
    label: t("failureFactor"),
    labelIcon: /* @__PURE__ */ React.createElement(HelpItem, {
      helpText: "realm-settings-help:failureFactor",
      fieldLabelId: "realm-settings:failureFactor"
    }),
    fieldId: "failureFactor",
    style: enable ? {} : {display: "none"}
  }, /* @__PURE__ */ React.createElement(Controller, {
    name: "failureFactor",
    defaultValue: 0,
    control,
    rules: {required: true},
    render: ({onChange, value}) => /* @__PURE__ */ React.createElement(NumberInput, {
      type: "text",
      id: "failureFactor",
      value,
      onPlus: () => onChange(value + 1),
      onMinus: () => onChange(value - 1),
      onChange: (event) => onChange(Number(event.target.value))
    })
  })), /* @__PURE__ */ React.createElement(FormGroup, {
    label: t("permanentLockout"),
    fieldId: "permanentLockout",
    hasNoPaddingTop: true,
    style: enable ? {} : {display: "none"}
  }, /* @__PURE__ */ React.createElement(Controller, {
    name: "permanentLockout",
    defaultValue: false,
    control,
    render: ({onChange, value}) => /* @__PURE__ */ React.createElement(Switch, {
      id: "permanentLockout",
      label: t("common:on"),
      labelOff: t("common:off"),
      isChecked: value,
      onChange
    })
  })), /* @__PURE__ */ React.createElement(Time, {
    name: "waitIncrementSeconds",
    style: enable && !permanentLockout ? {} : {display: "none"}
  }), /* @__PURE__ */ React.createElement(Time, {
    name: "maxFailureWaitSeconds",
    style: enable && !permanentLockout ? {} : {display: "none"}
  }), /* @__PURE__ */ React.createElement(Time, {
    name: "maxDeltaTimeSeconds",
    style: enable && !permanentLockout ? {} : {display: "none"}
  }), /* @__PURE__ */ React.createElement(FormGroup, {
    label: t("quickLoginCheckMilliSeconds"),
    labelIcon: /* @__PURE__ */ React.createElement(HelpItem, {
      helpText: "realm-settings-help:quickLoginCheckMilliSeconds",
      fieldLabelId: "realm-settings:quickLoginCheckMilliSeconds"
    }),
    fieldId: "quickLoginCheckMilliSeconds",
    style: enable ? {} : {display: "none"}
  }, /* @__PURE__ */ React.createElement(Controller, {
    name: "quickLoginCheckMilliSeconds",
    defaultValue: 0,
    control,
    render: ({onChange, value}) => /* @__PURE__ */ React.createElement(NumberInput, {
      type: "text",
      id: "quickLoginCheckMilliSeconds",
      value,
      onPlus: () => onChange(value + 1),
      onMinus: () => onChange(value - 1),
      onChange: (event) => onChange(Number(event.target.value))
    })
  })), /* @__PURE__ */ React.createElement(Time, {
    name: "minimumQuickLoginWaitSeconds",
    style: enable ? {} : {display: "none"}
  }), /* @__PURE__ */ React.createElement(ActionGroup, null, /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    type: "submit",
    "data-testid": "brute-force-tab-save",
    isDisabled: !isDirty
  }, t("common:save")), /* @__PURE__ */ React.createElement(Button, {
    variant: "link",
    onClick: reset
  }, t("common:revert"))));
};
